<template>
  <div class="mobile-page">
    <!-- 顶部悬浮按钮 -->
    <div class="m-float-btn" @click="title_btn" v-if="isbool3">
      <img class="m-float-del" @click.stop="isbool3 = false"
        src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/e6ee8cfeb6f03d0741f782bc2530497f.png" alt="" />
    </div>

    <!-- 头部 -->
    <div class="m-header">
      <div class="m-header-top">
        <div style="display: flex;">
          <img class="m-header-logo"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/923c92e5b46970ce566f6dbe2b834957.png" alt="" />
          <div>
            <span class="m-header-name">保彼通</span>
            <span class="m-header-name2">BobiTon</span>
          </div>
        </div>
        <img @click="right_isbool" class="m-header-menu"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/768a7029de061f475f746e4531e2f21d.png" alt="" />
      </div>
      <div style="width: 100%; height: 48px;"></div>
      <div>
        <img class="m-header-banner"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250508/65173a5b4ac7636480ffafab0184f635.jpg" alt="" />
      </div>
    </div>

    <!-- 产品优势 -->
    <div class="m-section1">
      <div class="m-section-title">我们的产品优势</div>
      <div class="m-tab-row">
        <div class="m-tab-item" :class="{ 'm-tab-active': num1 === 1 }" @click="num1 = 1">SAAS工具服务商</div>
        <div class="m-tab-item" :class="{ 'm-tab-active': num1 === 2 }" @click="num1 = 2">解决供货难题</div>
        <div class="m-tab-item" :class="{ 'm-tab-active': num1 === 3 }" @click="num1 = 3">产品迭代快速</div>
      </div>

      <div class="m-detail" v-if="num1 === 1">
        <div class="m-detail-title">多平台聚合</div>
        <div class="m-detail-desc">精准对接中大型企业级招商团队及媒体机构，打造高效精准的运营模式。</div>
        <div class="m-detail-row">
          <img class="m-detail-img"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/0d8590bd9ee08ddc6b963215d3818d3c.png" alt="" />
          <div class="m-detail-list">
            <div class="m-detail-item">
              <img class="m-detail-dot"
                src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
              <span class="m-detail-text">深度挖掘企业级招商团队的运营痛点</span>
            </div>
            <div class="m-detail-item">
              <img class="m-detail-dot"
                src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
              <span class="m-detail-text">精准掌握企业级招商团队的运营数据</span>
            </div>
            <div class="m-detail-item">
              <img class="m-detail-dot"
                src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
              <span class="m-detail-text">优化企业级招商团队的运营效率</span>
            </div>
          </div>
        </div>
      </div>

      <div class="m-detail" v-if="num1 === 2">
        <div class="m-detail-title">智能化、数字化的运营方式</div>
        <div class="m-detail-desc">实现了对公域流量和私域流量的全面管理与优化。</div>
        <div class="m-detail-row">
          <img class="m-detail-img"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/061b2eee635bf18211102329f7038d01.png" alt="" />
          <div class="m-detail-list">
            <div class="m-detail-item">
              <img class="m-detail-dot"
                src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
              <span class="m-detail-text">发布任务、数据追踪，深度挖掘公域流量价值</span>
            </div>
            <div class="m-detail-item">
              <img class="m-detail-dot"
                src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
              <span class="m-detail-text">实时监控、数据分析，赋能商家产品高效流通</span>
            </div>
            <div class="m-detail-item">
              <img class="m-detail-dot"
                src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
              <span class="m-detail-text">构建从公域流量到销售转化的完整业务链路</span>
            </div>
          </div>
        </div>
      </div>

      <div class="m-detail" v-if="num1 === 3">
        <div class="m-detail-title">强大的市场洞察力和精准的应变能力</div>
        <div class="m-detail-desc">在复杂多变的市场环境中展现出卓越的适应力。</div>
        <div class="m-detail-row">
          <img class="m-detail-img"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/720a4bee9b69d108fe12ae9b6bac5e04.png" alt="" />
          <div class="m-detail-list">
            <div class="m-detail-item">
              <img class="m-detail-dot"
                src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
              <span class="m-detail-text">快速洞察市场趋势，灵活调整产品策略</span>
            </div>
            <div class="m-detail-item">
              <img class="m-detail-dot"
                src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
              <span class="m-detail-text">帮助合作伙伴实现高效运营和业绩增长</span>
            </div>
            <div class="m-detail-item">
              <img class="m-detail-dot"
                src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
              <span class="m-detail-text">致力于为客户创造价值，推动行业整体发展</span>
            </div>
          </div>
        </div>
      </div>

      <div>
        <img class="m-footer-img"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/9fc740f0c04d1656aacc944e6093542e.png" alt="" />
        <div class="m-footer-text">
          保彼通平台致力于构建一个精准营销、数据驱动、公平透明的合作生态，为电商商家与达人合作提供解决方案。平台通过平台充值、发布精准任务、精准分销等创新功能，为商家提供精准营销、数据驱动的精准营销服务，为达人提供公平、透明、高效的合作模式，助力商家与达人达成共赢。
        </div>
      </div>
    </div>

    <!-- 保彼通工作台 -->
    <div class="m-section2">
      <div class="m-section-title" style="font-size: 16px; height: 22px; line-height: 22px;">保彼通bobiton工作台</div>
      <div class="m-section2-desc">精准发布任务、快速申请样品、随身追踪订单，满足从分销者日常运营所需，到企业级招商的需求</div>
      <div class="m-scroll-tabs" ref="scrollContainer">
        <div class="m-scroll-tab" v-for="(item, index) in list1" :key="index"
          :class="{ active: activeIndex === index }" @click="handleItemClick(index)">
          {{ item }}
        </div>
      </div>
      <div v-if="activeIndex === 0">
        <div class="m-work-img-box">
          <img class="m-work-img1"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/d4ba80844cf4dc46c5a6a48a79ca5a61.png" alt="" />
          <img class="m-work-img2"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/9889599db1be7ae36c80e5ff50dc52ca.png" alt="" />
        </div>
        <div class="m-work-tip">
          <img class="m-work-dot"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
          <span>任务细分为公开、专属，响应不同达人的不同带货需求，为达人定制专属任务补贴比例。</span>
        </div>
      </div>
      <div v-if="activeIndex === 1">
        <div class="m-work-img-box">
          <img class="m-work-img1"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/92aca8078d8aa40122a83e51c3e1ac3a.png" alt="" />
          <img class="m-work-img2"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/42adaa704dac94c77094b39b95566eb4.png" alt="" />
        </div>
        <div class="m-work-tip">
          <img class="m-work-dot"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
          <span>海量产品根据不同类目、价格、达人佣金、服务费供分销者和达人选择。</span>
        </div>
      </div>
      <div v-if="activeIndex === 2">
        <div class="m-work-img-box">
          <img class="m-work-img1"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/27d5913af5302790b2a5451e0131abb9.png" alt="" />
          <img class="m-work-img2"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de87b71f42085d645a4e69c588ad359d.png" alt="" />
        </div>
        <div class="m-work-tip">
          <img class="m-work-dot"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
          <span>海量产品根据不同类目、价格、达人佣金、服务费供分销者和达人选择。</span>
        </div>
      </div>
      <div v-if="activeIndex === 3">
        <div class="m-work-img-box">
          <img class="m-work-img1"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/fd4f867cf99b82f55822294879011c83.png" alt="" />
          <img class="m-work-img2"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/cd813a4cd9d4123e9140f6c7211f5f13.png" alt="" />
        </div>
        <div class="m-work-tip">
          <img class="m-work-dot"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
          <span>在小程序申样列表可进行申样进度跟踪,将申样负责人及每个环节的时间节点透明化管理。</span>
        </div>
      </div>
      <div v-if="activeIndex === 4">
        <div class="m-work-img-box">
          <img class="m-work-img1"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/c7b5fe5c5c80b788ea2915daae3f5c69.png" alt="" />
          <img class="m-work-img2"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/ace8f42261b08bbdb8e43396aa43057b.png" alt="" />
        </div>
        <div class="m-work-tip">
          <img class="m-work-dot"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
          <span>实时同步更新订单数据，精准计算有效销售金额及预估佣金，多维筛选查看功能一目了然。</span>
        </div>
      </div>
      <div v-if="activeIndex === 5">
        <div class="m-work-img-box">
          <img class="m-work-img1"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/bd97ccc12a4f9298124f0ccb57a1ce2b.png" alt="" />
          <img class="m-work-img2"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/72baf02b4b506d4f4630307d99d42d8a.png" alt="" />
        </div>
        <div class="m-work-tip">
          <img class="m-work-dot"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
          <span>精准分置钱包账户，零门槛零手续费提现，实时到账，佣金进出明细详尽。</span>
        </div>
      </div>
    </div>

    <!-- 招商工作台 -->
    <div class="m-section3">
      <div class="m-section3-inner">
        <div class="m-section3-title">保彼通招商工作台</div>
        <div class="m-section3-tabs">
          <div v-for="(item, index) in list2" :key="index" class="m-section3-tab"
            @click="activeIndex2 = index" :class="{ 'm-section3-tab-active': activeIndex2 === index }">{{ item }}</div>
        </div>
        <div v-if="activeIndex2 === 0">
          <img class="m-section3-img"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/4e7f10171963ce8e34dee6e5ce61d159.png" alt="" />
          <div>
            <div class="m-section3-subtitle">支持企业自定义设置</div>
            <div class="m-section3-line m-section3-line1"></div>
          </div>
          <div class="m-section3-desc">
            企业可自由选择保彼通提供的账号进行后台登录，以避免企业或第三方自行看到平台相关隐私信息。企业可灵活配置权限以满足不同业务需求，支持自定义的企业名称、企业介绍等重要信息，有助于提升企业品牌形象，增强员工对企业认同感。
          </div>
        </div>
        <div v-if="activeIndex2 === 1">
          <img class="m-section3-img"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/8d223f0f82a4f5f9621aee75f07a4360.png" alt="" />
          <div>
            <div class="m-section3-subtitle">数据精准分析，深度挖掘价值</div>
            <div class="m-section3-line m-section3-line2"></div>
          </div>
          <div class="m-section3-desc">
            帮助企业精准洞察用户行为与市场趋势，深度挖掘数据价值，优化运营效率，提升决策能力。通过大数据分析，全面了解分销者需求与企业运营模式，助力企业快速响应与改进，实现业务持续优化与增长。
          </div>
        </div>
        <div v-if="activeIndex2 === 2">
          <img class="m-section3-img"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/0ad8c1651bff660993d99c3e6e3f8f44.png" alt="" />
          <div>
            <div class="m-section3-subtitle">达人自由录入、寄样管理</div>
            <div class="m-section3-line m-section3-line3"></div>
          </div>
          <div class="m-section3-desc">
            申请样品管理采用智能绑定技术，将分销者和达人信息自动绑定至样品申请，实现精准匹配。该系统支持分销者为达人批量配送样品，提升效率。
          </div>
        </div>
        <div v-if="activeIndex2 === 3">
          <img class="m-section3-img"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/49df08402eaea8975e4e7994bb9d326d.png" alt="" />
          <div>
            <div class="m-section3-subtitle">活动集中管理、支持多员工分配</div>
            <div class="m-section3-line m-section3-line4"></div>
          </div>
          <div class="m-section3-desc">
            通过智能绑定技术，将活动对象精准分配至多个人员或团队，有效避免因活动限制而难以吸引目标员工参与。活动状态清晰区分，采用自动化处理技术，实时统计活动审核通过商品数、待审核商品数及申请商品情况。
          </div>
        </div>
      </div>
    </div>

    <!-- 深入理解业务 -->
    <div class="m-section4">
      <div class="m-section4-title">深入理解业务</div>
      <div class="m-section4-title" style="margin-bottom: 20px;">让每个角色都能为团队提升效率贡献力量</div>
      <div class="m-card-grid">
        <div class="m-card" v-for="(card, i) in cards" :key="i">
          <img class="m-card-img" :src="card.img" alt="" />
          <div class="m-card-name">{{ card.name }}</div>
        </div>
      </div>
    </div>

    <!-- 商家端 -->
    <div class="m-section5">
      <div class="m-section5-title">商家端</div>
      <div class="m-section5-desc">无论品牌商家还是团长机构，全场景、全平台、全链路数字化一站式解决方案</div>
      <div>
        <img class="m-section5-banner"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/5a431c673c6dd5a4ee748a97085a21e8.png" alt="" />
      </div>
      <div class="m-section5-tabs">
        <div v-for="(item, index) in list3" :key="index" class="m-section5-tab"
          @click="activeIndex3 = index" :class="{ 'm-section5-tab-active': activeIndex3 === index }">{{ item }}</div>
      </div>
      <div class="m-section5-subtitle2">无论你是招商人员还是分销者都能找到契合使用场景的业务解决方案</div>
      <div v-if="activeIndex3 === 0">
        <img class="m-section5-banner2"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/626b82515980243ec7e67afab105ecc0.png" alt="" />
        <div class="m-section5-role">招商</div>
        <div class="m-section5-role-desc">招商专员负责寻找优质商家资源、提报活动、审核商品质量、发布任务、协商产品优惠力度及推广佣金细节。</div>
        <div>
          <div class="m-detail-item">
            <img class="m-detail-dot2"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
            <span class="m-section5-item-text">*活动创建、商品审核、任务发布、跨平台交互 招商员工可直接在后台，完成"活动创建""商品审核""任务发布""申样流程"等一系列工作。</span>
          </div>
          <div class="m-detail-item">
            <img class="m-detail-dot2"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
            <span class="m-section5-item-text">*系统全自动同步活动，同步商品 系统自动同步招商后台创建的活动和添加的商品，无需其他导出导入操作。</span>
          </div>
          <div class="m-detail-item">
            <img class="m-detail-dot2"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
            <span class="m-section5-item-text">*数据自动同步，多维度提供榜单数据 自动同步招商工作数据，无需任何手动计算，可直接进行多维度分析数据</span>
          </div>
        </div>
      </div>
      <div v-if="activeIndex3 === 1">
        <img class="m-section5-banner2"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/bb48494a8fb4d2861969e4bbe17f4fcf.png" alt="" />
        <div class="m-section5-role">分销者</div>
        <div class="m-section5-role-desc">精准定位管理主播达人，通过模块化推广运营管理提升推广效率，实现事半功倍的推广效果。</div>
        <div>
          <div class="m-detail-item">
            <img class="m-detail-dot2"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
            <span class="m-section5-item-text">精准定位管理主播达人，通过模块化推广运营管理提升推广效率，实现事半功倍的推广效果。</span>
          </div>
          <div class="m-detail-item">
            <img class="m-detail-dot2"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
            <span class="m-section5-item-text">*数据成交订单同步，多维度提供榜单数据 达人订单数据精准统计，商务BD业绩自动计算，分佣自动到账。</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 合作伙伴 -->
    <div class="m-section6">
      <div class="m-section6-inner">
        <div class="m-section6-title">合作伙伴</div>
        <img class="m-section6-img"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/99d31e329d88e3d7f98785c1e2c78d86.png" alt="" />
      </div>
    </div>

    <!-- 联系我们 -->
    <div class="m-section7" ref="targetElement">
      <div class="m-section7-title">联系我们</div>
      <div>
        <div class="m-contact-row">
          <img class="m-contact-dot"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/156790c1800faf74ab870ef872d70255.png" alt="" />
          <div class="m-contact-text">
            优艾弗欧信息科技有限公司以保彼通平台为核心，专注于为商家、团长和主播选品负责人提供优质服务。通过整合和分发全网爆款产品，并对团长团队服务进行流程化管理，我们致力于推动新型消费服务的创新与发展。
          </div>
        </div>
        <div class="m-contact-row">
          <img class="m-contact-dot"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/156790c1800faf74ab870ef872d70255.png" alt="" />
          <div class="m-contact-text">
            公司致力于打造全面的营销生态系统，涵盖供应链管理、品牌运营和直播孵化等关键业务。从产品源头严格把控每一个细节，力求将最优质、最健康的产品传递给每一位消费者。
          </div>
        </div>
        <div class="m-contact-row">
          <img class="m-contact-dot"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/156790c1800faf74ab870ef872d70255.png" alt="" />
          <div class="m-contact-text">
            在服务方面，我们秉承用户至上的理念，提供个性化、高效的售后支持，确保消费者享受无忧的购物体验。我们以数据驱动、技术赋能，不断优化服务流程，提高服务效率和质量。
          </div>
        </div>
        <div class="m-contact-row">
          <img class="m-contact-dot"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/156790c1800faf74ab870ef872d70255.png" alt="" />
          <div class="m-contact-text">
            我们将不断探索创新，持续提升服务水平，努力成为消费者最信赖的产品服务商。我们期待与广大消费者共同见证新消费时代的到来，共享美好生活的每一个瞬间。
          </div>
        </div>
        <div>
          <div class="m-contact-imgs">
            <img class="m-contact-qr"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/fe119d4f595555932d9a3d03ca529632.png" alt="" />
            <img class="m-contact-qr"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/a85341246f869f35b6c26a410129ea81.png" alt="" />
          </div>
          <div class="m-contact-labels">
            <div class="m-contact-label">长按保存公众号图片</div>
            <div class="m-contact-label">长按保存客服微信图片</div>
          </div>
        </div>
      </div>
    </div>

    <!-- APP -->
    <div class="m-section8">
      <div class="m-section5-title">保彼通APP上线啦</div>
      <div>
        <div class="m-section5-role">保彼通是一款互联网直播电商数字分销平台。</div>
        <div>
          <div class="m-detail-item">
            <img class="m-detail-dot2"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
            <span class="m-section5-item-text">解决直播电商的分销痛点，并通过数智兵工场的线下场景及自营分销团队实现推品功能。</span>
          </div>
          <div class="m-detail-item">
            <img class="m-detail-dot2"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
            <span class="m-section5-item-text">为广大商家提供高效便捷的推品服务。</span>
          </div>
          <div class="m-detail-item">
            <img class="m-detail-dot2"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/de0cd237ffd7ce17199cf11cc0cb967a.png" alt="" />
            <span class="m-section5-item-text">为平台的所有客户提供免费的数字管理工具服务。</span>
          </div>
        </div>
      </div>
      <div>
        <div class="m-download-btns">
          <div class="m-download-btn" @click="down_app('ios')">
            <span>IOS下载</span>
            <img class="m-download-icon"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250529/a0e3721d8c89a0d265cb52d86c29c9d1.png" alt="" />
          </div>
          <div class="m-download-btn" @click="down_app('Android')">
            <span>Android版下载</span>
            <img class="m-download-icon"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250529/a0e3721d8c89a0d265cb52d86c29c9d1.png" alt="" />
          </div>
        </div>
        <div style="display: flex; justify-content: center; margin-top: 20px;">
          <img class="m-download-preview"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250529/e7f5945fd23eddeea13c801db4a78ff0.png" alt="" />
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="m-footer">
      <div class="m-footer-text2">邮箱：baobitong@ufozx.com</div>
      <div class="m-footer-text2">浙ICP备2024099946号-7｜杭州优艾弗欧信息科技有限公司</div>
      <div class="m-footer-text2">© CopyRight 2023-2025 版权所有</div>
    </div>

    <!-- 侧边栏弹窗 -->
    <div class="m-sidebar-mask" v-if="sidebarOpen" @click="sidebarOpen = false">
      <div class="m-sidebar" @click.stop>
        <div class="m-sidebar-header">
          <div style="display: flex;">
            <img class="m-sidebar-logo"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/923c92e5b46970ce566f6dbe2b834957.png" alt="" />
            <div>
              <span class="m-sidebar-name">保彼通</span>
              <span class="m-sidebar-name2">BobiTon</span>
            </div>
          </div>
          <div>
            <img class="m-sidebar-close"
              src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/c67ff5774d796e92f25e0f4644dd7510.png" alt="" />
          </div>
        </div>
        <div class="m-sidebar-divider"></div>
        <div>
          <div v-for="(item, index) in list4" :key="index" class="m-sidebar-item" @click="scrollToElement(index)">
            <span class="m-sidebar-item-text">{{ item }}</span>
            <div>
              <img class="m-sidebar-arrow"
                src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/9172d92039736427b635344a75b2381c.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      num1: 1,
      list1: ['任务主页', '选品大厅', '达人申样', '申样跟踪管理', '任务订单数据', '分佣无门槛提现'],
      activeIndex: 0,
      list2: ['企业管理', '数据分析', '达人管理', '活动管理'],
      activeIndex2: 0,
      list3: ['招商', '分销者'],
      activeIndex3: 0,
      list4: ['首页', '产品优势', '关于我们', '保彼通APP', '开放平台'],
      isbool3: true,
      sidebarOpen: false,
      cards: [
        { img: 'https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/f3dfe6992d3e73d7789ebc3834b4ba1c.png', name: '活动管理' },
        { img: 'https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/a4e05fa608899b24075c72a92aa25fe1.png', name: '商品管理' },
        { img: 'https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/e65ca0e4cbe83d95e6a8272d707c6539.png', name: '样品管理' },
        { img: 'https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/12f156ec8836638801c0b9468637dcdb.png', name: '订单管理' },
        { img: 'https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/780bcc9db8e0a2958abea4280a580417.png', name: '任务管理' },
        { img: 'https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/411ab8a47786cb6bcd41956dd2dec579.png', name: '绩效管理' },
        { img: 'https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/e969d5f03dc031fc0a7e5e4b55efb4cf.png', name: '达人管理' },
        { img: 'https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/03b78756b7212b53155f0025abd399e4.png', name: '排行管理' },
        { img: 'https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/b78556b83bef859327d988d89bddbedd.png', name: '企业管理' }
      ]
    }
  },
  methods: {
    handleItemClick(index) {
      this.activeIndex = index;
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer;
        if (!container) return;
        const items = container.children;
        if (!items[index]) return;
        const item = items[index];
        const containerWidth = container.clientWidth;
        const itemLeft = item.offsetLeft;
        const itemWidth = item.clientWidth;
        let scrollTo = itemLeft - (containerWidth / 2) + (itemWidth / 2);
        scrollTo = Math.max(0, Math.min(scrollTo, container.scrollWidth - containerWidth));
        container.scrollTo({ left: scrollTo, behavior: 'smooth' });
      });
    },
    right_isbool() {
      this.sidebarOpen = true
    },
    scrollToElement(index) {
      this.sidebarOpen = false
      const targets = ['.m-header', '.m-section1', '.m-section6', '.m-section8', null]
      if (index === 4) {
        this.$message.info('暂未开放～')
        return
      }
      const selector = targets[index]
      if (!selector) return
      this.$nextTick(() => {
        const el = document.querySelector(selector)
        if (el) {
          const rect = el.getBoundingClientRect()
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop
          window.scrollTo({ top: rect.top + scrollTop - 44, behavior: 'smooth' })
        }
      })
    },
    title_btn() {
      this.$nextTick(() => {
        const el = document.querySelector('.m-footer')
        if (el) {
          const rect = el.getBoundingClientRect()
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop
          window.scrollTo({ top: rect.top + scrollTop, behavior: 'smooth' })
        }
      })
    },
    down_app(name) {
      if (name === 'Android') {
        window.location.href = 'https://oss.bobiton.com/__UNI__8920217_0529174049.apk'
      } else {
        this.$message.info('暂未开放～')
      }
    }
  }
}
</script>

<style>
/* ========== 移动端页面样式 (375px 设计稿) ========== */
.mobile-page {
  max-width: 480px;
  margin: 0 auto;
  overflow-x: hidden;
}

/* ---- 浮动按钮 ---- */
.m-float-btn {
  z-index: 9;
  background-image: url('https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/f5394c53c84560189249c7009c4a11aa.png');
  background-size: 58px 61px;
  width: 58px;
  height: 61px;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 15px;
  margin: auto;
}
.m-float-del {
  position: absolute;
  top: -7px;
  right: -7px;
  width: 14px;
  height: 14px;
}

/* ---- 头部 ---- */
.m-header { width: 100%; }
.m-header-top {
  z-index: 2;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 15px;
  line-height: 48px;
  background: #FFFFFF;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}
.m-header-logo { margin-top: 15px; margin-right: 5px; width: 18px; height: 18px; }
.m-header-name { font-weight: 600; font-size: 15px; color: #333333; }
.m-header-name2 { font-weight: 600; font-size: 11px; color: #333333; }
.m-header-menu { width: 16px; height: 14px; margin-top: 17px; }
.m-header-banner { width: 100%; height: 442px; }

/* ---- 通用标题 ---- */
.m-section-title { font-weight: 600; font-size: 16px; color: #000000; text-align: center; height: 22px; line-height: 22px; }

/* ---- 产品优势 ---- */
.m-section1 {
  width: 100%;
  background-color: #F3F8FE;
  padding: 30px 19px;
  box-sizing: border-box;
}
.m-tab-row {
  margin: 20px 0;
  width: 100%;
  height: 39px;
  background: #FFFFFF;
  border-radius: 21px;
  display: flex;
  justify-content: space-evenly;
}
.m-tab-item {
  text-align: center;
  line-height: 31px;
  margin-top: 4px;
  width: 107px;
  height: 31px;
  border-radius: 16px;
  font-size: 12px;
  color: #000000;
}
.m-tab-active {
  background: linear-gradient(90deg, #3880F7 0%, #5CA2FE 100%);
  color: #fff;
}
.m-detail-title { line-height: 20px; margin-bottom: 8px; font-weight: 600; font-size: 14px; color: #000000; }
.m-detail-desc { font-size: 12px; color: #666666; line-height: 17px; margin-bottom: 20px; }
.m-detail-row { display: flex; justify-content: space-between; }
.m-detail-img { width: 165px; height: 143px; }
.m-detail-list { margin-top: 11px; }
.m-detail-item { display: flex; margin-bottom: 10px; }
.m-detail-dot { margin-top: 4px; margin-right: 11px; width: 8px; height: 10px; flex-shrink: 0; }
.m-detail-dot2 { margin-top: 7px; margin-right: 9px; width: 9px; height: 13px; flex-shrink: 0; }
.m-detail-text { width: 130px; font-size: 12px; color: #333333; line-height: 17px; }
.m-footer-img { margin-top: 20px; width: 100%; height: 118px; margin-bottom: 12px; }
.m-footer-text { font-size: 12px; color: #333333; line-height: 17px; }

/* ---- 保彼通工作台 ---- */
.m-section2 {
  background: linear-gradient(180deg, #CFEAFE 0%, #FFFFFF 100%);
  width: 100%;
  padding: 30px 15px;
  box-sizing: border-box;
}
.m-section2-desc { margin-top: 8px; line-height: 17px; font-size: 12px; color: #666666; text-align: center; }
.m-scroll-tabs {
  padding: 0 4px;
  overflow-x: auto;
  display: flex;
  margin: 20px 0;
  width: 100%;
  height: 39px;
  background: #FFFFFF;
  border-radius: 21px;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  box-sizing: border-box;
}
.m-scroll-tab {
  height: 31px;
  line-height: 31px;
  margin-top: 4px;
  padding: 0 18px;
  border-radius: 16px;
  font-size: 12px;
  color: #000;
  flex-shrink: 0;
}
.m-scroll-tab.active {
  background: linear-gradient(90deg, #3880F7 0%, #5CA2FE 100%);
  color: #fff;
}
.m-work-img-box { position: relative; width: 100%; }
.m-work-img1 { width: 100%; height: 200px; }
.m-work-img2 { width: 88px; height: 168px; position: absolute; bottom: 0; right: 0; }
.m-work-tip { display: flex; margin-top: 7px; }
.m-work-dot { margin-left: 5px; margin-top: 3px; margin-right: 10px; width: 9px; height: 10px; flex-shrink: 0; }
.m-work-tip span { font-size: 12px; color: #333333; line-height: 17px; }

/* ---- 招商工作台 ---- */
.m-section3 {
  background-image: url('https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/3a4da3407908ca87d565eed9c16cd7f0.png');
  background-size: 100% auto;
  width: 100%;
}
.m-section3-inner {
  padding: 30px 19px;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  box-sizing: border-box;
}
.m-section3-title { margin-bottom: 20px; font-weight: 600; font-size: 16px; color: #FFFFFF; text-align: center; }
.m-section3-tabs { display: flex; justify-content: space-between; margin-bottom: 20px; }
.m-section3-tab {
  width: 84px; height: 31px; border-radius: 16px; text-align: center; line-height: 31px;
  font-size: 12px; color: #FFFFFF;
}
.m-section3-tab-active { background: linear-gradient(90deg, #3880F7 0%, #5CA2FE 100%); }
.m-section3-img { margin: 20px auto 12px; display: block; width: 300px; height: 192px; }
.m-section3-subtitle { font-weight: 600; font-size: 14px; color: #FFFFFF; line-height: 20px; }
.m-section3-desc { margin-top: 8px; font-size: 12px; color: #FFFFFF; line-height: 17px; }
.m-section3-line { height: 6px; background: #3A70F5; margin-top: -5px; margin-bottom: 8px; }
.m-section3-line1 { width: 128px; }
.m-section3-line2 { width: 184px; }
.m-section3-line3 { width: 156px; }
.m-section3-line4 { width: 198px; }

/* ---- 业务 ---- */
.m-section4 {
  padding: 30px 19px;
  background: #F3F8FE;
  box-sizing: border-box;
}
.m-section4-title { text-align: center; line-height: 22px; font-weight: 600; font-size: 16px; color: #000000; }
.m-card-grid { display: flex; flex-wrap: wrap; justify-content: space-between; }
.m-card {
  margin-bottom: 12px; padding-top: 16px; text-align: center;
  width: 104px; height: 88px; background: #E8F1FF; border-radius: 10px;
}
.m-card-img { width: 48px; height: 48px; }
.m-card-name { margin-top: 4px; font-size: 13px; color: #000000; }

/* ---- 商家端 ---- */
.m-section5 { padding: 30px 19px; box-sizing: border-box; }
.m-section5-title { font-weight: 600; font-size: 16px; color: #000000; line-height: 22px; text-align: center; margin-bottom: 8px; }
.m-section5-desc { font-size: 12px; color: #666666; line-height: 17px; text-align: center; margin: 0 20px 18px; }
.m-section5-banner { margin-top: 18px; width: 100%; height: 200px; }
.m-section5-tabs {
  font-size: 12px; padding: 4px; margin: 18px auto 0;
  display: flex; width: 225px; height: 39px; background: #FFFFFF; border-radius: 21px; box-sizing: border-box;
}
.m-section5-tab { width: 82px; height: 31px; border-radius: 16px; line-height: 31px; text-align: center; }
.m-section5-tab-active { background: linear-gradient(90deg, #3880F7 0%, #5CA2FE 100%); color: #fff; }
.m-section5-subtitle2 { margin: 9px auto 6px; font-size: 12px; color: #666666; text-align: center; line-height: 17px; }
.m-section5-banner2 { width: 100%; height: 200px; }
.m-section5-role { height: 38px; line-height: 38px; font-weight: 600; font-size: 14px; color: #000000; }
.m-section5-role-desc { font-size: 12px; color: #666666; line-height: 17px; margin-bottom: 12px; }
.m-section5-item-text { margin-bottom: 12px; font-size: 12px; color: #333333; line-height: 25px; }

/* ---- 合作伙伴 ---- */
.m-section6 {
  position: relative; width: 100%; height: 236px;
  background-image: url('https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/d12227ac8c2b2c84009108dfaa0ecaac.png');
  background-size: 100% 236px;
}
.m-section6-inner {
  padding: 30px 19px; position: absolute; width: 100%; height: 176px;
  top: 0; left: 0; background-color: rgba(0, 0, 0, 0.7); box-sizing: border-box;
}
.m-section6-title { line-height: 22px; margin-bottom: 20px; text-align: center; font-weight: 600; font-size: 16px; color: #FFFFFF; }
.m-section6-img { width: 100%; height: 134px; }

/* ---- 联系我们 ---- */
.m-section7 {
  padding: 30px 19px 0;
  background-image: url('https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250411/5226a70954be65434b41613a245384e9.png');
  background-size: 100% auto;
  box-sizing: border-box;
}
.m-section7-title { font-weight: 600; font-size: 16px; color: #FFFFFF; text-align: center; margin-bottom: 20px; }
.m-contact-row { display: flex; margin-bottom: 12px; }
.m-contact-dot { margin-right: 10px; width: 9px; height: 14px; flex-shrink: 0; margin-top: 3px; }
.m-contact-text { font-size: 12px; color: #FFFFFF; line-height: 17px; }
.m-contact-imgs { display: flex; justify-content: space-between; margin-top: 20px; }
.m-contact-qr { width: 120px; height: 120px; }
.m-contact-labels { display: flex; justify-content: space-between; margin-top: 10px; }
.m-contact-label {
  width: 164px; height: 32px; background: #FFFFFF; border-radius: 18px;
  text-align: center; line-height: 32px; font-weight: 600; font-size: 12px; color: #3A70F5;
}

/* ---- APP ---- */
.m-section8 { background: linear-gradient(180deg, #CFEAFE 0%, #FFFFFF 100%); padding: 30px 25px; box-sizing: border-box; }
.m-download-btns { margin-top: 20px; display: flex; justify-content: space-between; }
.m-download-btn {
  width: 147px; height: 32px; background: linear-gradient(90deg, #3880F7 0%, #5CA2FE 100%);
  border-radius: 34px; line-height: 32px; display: flex; justify-content: center;
  font-weight: 600; font-size: 12px; color: #FFFFFF;
}
.m-download-icon { margin-top: 9px; width: 15px; margin-left: 8px; height: 15px; }
.m-download-preview { width: 276px; height: 229px; }

/* ---- 底部 ---- */
.m-footer {
  padding: 14px; background: #171E2F; box-sizing: border-box;
}
.m-footer-text2 { font-size: 11px; color: #B9BABB; text-align: center; line-height: 16px; }

/* ---- 侧边栏 ---- */
.m-sidebar-mask {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.4); z-index: 9999;
}
.m-sidebar {
  position: fixed; top: 0; right: 0; bottom: 0;
  width: 240px; padding: 15px 20px;
  background-color: #fff; border-radius: 20px 0 0 20px; box-sizing: border-box;
}
.m-sidebar-header { display: flex; justify-content: space-between; }
.m-sidebar-logo { width: 18px; margin-right: 5px; margin-top: 3px; height: 18px; }
.m-sidebar-name { font-weight: 600; font-size: 15px; color: #333333; }
.m-sidebar-name2 { font-weight: 600; font-size: 11px; color: #333333; }
.m-sidebar-close { margin-top: 3px; width: 18px; height: 18px; }
.m-sidebar-divider {
  margin: 15px -20px 15px; height: 1px; border-bottom: 1px dashed #666;
  width: calc(100% + 40px);
}
.m-sidebar-item { margin-bottom: 20px; display: flex; justify-content: space-between; cursor: pointer; }
.m-sidebar-item-text { font-size: 13px; color: #000000; }
.m-sidebar-arrow { height: 12px; width: 12px; }
</style>
